export default "__VITE_ASSET__BFblPexE__"